import { RootState } from "../../../Redux/store";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";
import React from "react";

interface PrivateRouteProps {
  children: React.ReactNode;
  isAdmin?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  isAdmin = false,
}) => {
  const { token, user, admin, adminToken } = useSelector(
    (state: RootState) => state.auth,
  );
  const isAuthenticated = token && user;
  const isAdminAuthenticated = admin && adminToken;

  if (isAdmin && !isAdminAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!isAuthenticated && !isAdmin) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
